(function () {
    'use strict';

    angular
        .module('app.errorPage', [
            'app.core',
            'utils'
        ]);
})();